import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {updateTax, getTax} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {bindActionCreators} from "redux";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateTaxForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.taxId !== this.props.match.params.taxId) {
      this._load();
    }
  }

  _load = () => {
    const {taxId} = decodeParams(this.props.match.params);
    this.props.getTax({taxId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {taxId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.updateTax({...values, taxId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, tax} = this.props;
    const {name, description, registrationNumber} = tax;
    return (
      <Card title="Update Tax">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Description"
          >
            {getFieldDecorator('description', {
              initialValue: description
            })(
              <TextArea />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Registration Number"
          >
            {getFieldDecorator('registrationNumber', {
              initialValue: registrationNumber
            })(
              <Input />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Tax
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdateTaxForm.propTypes = {
  form: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispensaryId: PropTypes.string.isRequired,
  updateTax: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  tax: PropTypes.object.isRequired,
  getTax: PropTypes.func.isRequired,
};

const UpdateTaxPage = Form.create()(UpdateTaxForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  loading: state.tax.taxLoading || state.tax.updatingTax,
  tax: state.tax.tax || {},
});

const mapDispatchToProps = dispatch => ({
  updateTax: bindActionCreators(updateTax, dispatch),
  getTax: payload => (dispatch(getTax(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateTaxPage);



// WEBPACK FOOTER //
// ./src/Tax/UpdateTaxPage.js